import {
    FormattedAmount,
    formatAmountWithNumberFormatResult,
    formatPercentWithNumberFormatResult,
} from "@common/helpers/number";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";

export const formatPreviewPercent = (
    value: number,
    format: NumberFormatValues,
): FormattedAmount =>
    formatPercentWithNumberFormatResult({ numberFormat: format, value });

export const formatPreviewAmount = (
    value: number,
    format: NumberFormatValues,
): FormattedAmount =>
    formatAmountWithNumberFormatResult({ numberFormat: format, value });
